function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 20,
  height: 15,
  rx: 2,
  fill: "#F5F8FB"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 7.5,
  r: 3.75,
  fill: "#DC251C"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.75 11.875V8.125C12.4986 5.93508 9.99585 7.73722 9.99585 7.73722C9.99585 7.73722 7.49862 9.37224 6.25 6.875V11.875H13.75Z",
  fill: "#C4C4C4"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0_11403_387000)"
}, React.createElement("circle", {
  cx: 10,
  cy: 7.5,
  r: 3.75,
  fill: "#41479B"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.70508 4.61206L4.58008 1.36447",
  stroke: "black",
  strokeWidth: 0.625
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.54004 5.09424L5.41504 1.84664",
  stroke: "black",
  strokeWidth: 0.625
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.37598 5.57642L6.25098 2.32882",
  stroke: "black",
  strokeWidth: 0.625
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.2949 4.61206L15.4199 1.36447",
  stroke: "black",
  strokeWidth: 0.625,
  strokeDasharray: "10 1.25"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.46 5.09424L14.585 1.84664",
  stroke: "black",
  strokeWidth: 0.625
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.624 5.57642L13.749 2.32882",
  stroke: "black",
  strokeWidth: 0.625,
  strokeDasharray: "10 1.25"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.70508 10.3879L4.58008 13.6355",
  stroke: "black",
  strokeWidth: 0.625
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.54004 9.90576L5.41504 13.1534",
  stroke: "black",
  strokeWidth: 0.625,
  strokeDasharray: "10 1.25"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.37598 9.42358L6.25098 12.6712",
  stroke: "black",
  strokeWidth: 0.625
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.2949 10.3879L15.4199 13.6355",
  stroke: "black",
  strokeWidth: 0.625,
  strokeDasharray: "10 1.25"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.46 9.90576L14.585 13.1534",
  stroke: "black",
  strokeWidth: 0.625,
  strokeDasharray: "10 1.25"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.624 9.42358L13.749 12.6712",
  stroke: "black",
  strokeWidth: 0.625,
  strokeDasharray: "10 1.25"
});

var SvgIconFlagKrDark = function SvgIconFlagKrDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, React.createElement("mask", {
    id: "mask0_11403_387000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 8,
    height: 6
  }, _ref4), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFlagKrDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_flag_kr_dark.90421cd5.svg";
export { ForwardRef as ReactComponent };